export const permissionMap = {
  MemberLookup: 1,
  MemberProfile: 2,
  Transactions: 101,
  Vouchers: 102,
  Comms: 103,
  Memos: 104,
  Identification: 105,
  Membership: 106,
  Financials: 107,
  Subsquad: 108,
  History: 100,
  MerchantLookup: 109,
  MerchantProfile: 110,
  MerchantIdentification: 111,
  MerchantDevice: 112,
  MerchantMemberships: 113,
  MerchantBankAccounts: 118,
  CampaignList: 114,
  CampaignDetail: 115,
  VoucherList: 116,
  VoucherDetail: 117,
  ReportsList: 300,
  ReportsDetail: 301,
  ReportsView: 302,
  HDAReports: 200,
  HDAReports_MemberTransactionsReports: 201,
  BulkTransactions: 400,
}
